import { type Manifest, type RouterConfig, PAGE_TYPE } from '@/types/manifest';

const routerConfig: RouterConfig = {
    type: PAGE_TYPE.PAGE,
    name: 'assistant',
    // 通配子路径，使 assistant 子应用的内层路由（如 /chat/<id>）直接长在宿主 path 上，
    // 形如 #/assistant/chat/<id>?task_id=<x>，像原生地址一样可读、可深链、无歧义。
    exclusiveRoutePath: '/assistant/:assistantPath(.*)?',
    getComponent: () => import('./Assistant.vue'),
};

export const manifest: Manifest = {
    ...routerConfig,
};

declare module '@patsnap/tahiti-core' {
    export interface CommandService {
        /**
         * Go to Assistant page.
         */
        executeCommand(commandId: 'command:route:assistant'): void;
    }
}
